const useLoadCatalogData = {
    methods: {
        async loadCatalogData(branchCode = 1000) {
            await this.$services.catalog.initialAsync(branchCode);
            this.$store.commit("catalog/setLoading", false);
        },
    },
};

export default useLoadCatalogData;
